import { Injectable } from '@angular/core';
import { CommonService } from '../Services/common.service';
import { ConfigSettingService } from '../Services/config-setting.service';
import { UpdateBalanceService } from '../Services/update-balance.service'
import { DataManipService } from '../Services/data-manip.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WalletTopupComponent } from '../containers/wallet-topup/wallet-topup.component';

const razerpaykey_Id = "rzp_test_YJpYX80CozUKWx";//Test
//const razerpaykey_Id="rzp_live_tMg4Fx116WmCb0";//Live

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  modalRef: any;

  constructor(public balanceupdate: UpdateBalanceService, public dataManipSrvc: DataManipService,
    private commonServices: CommonService, private configSetting: ConfigSettingService, private NgbModal: NgbModal, private NgbActiveModal: NgbActiveModal) {
    this.loadRazorPayScriptFileAsItIsNotLoadedAlready();
    this.amountToaddinwallet = 0;
  }
  currentPassword: string = "";
  newPassword: string = "";
  confPassword: string = "";
  passwordMatch: boolean = false;
  confirmPassErrMsg: string = "";
  changePassMsg: string = "";
  showLoader: boolean = false;
  userID: any;
  razorpayObject;
  razorOrderId;
  walletAmount;
  wallettext = "";
  amountToaddinwallet: any;
  amount = 0
page="";
  options = {

    "key": razerpaykey_Id,
    "amount": "2000",
    "currency": "INR",
    "name": "anand",
    "description": "Test RP",
    "image": "https://media.geeksforgeeks.org/wp-content/uploads/20210806114908/dummy-200x200.png",
    "order_id": "order_HdPuQW0s9hY9AU",
    "callback_url": "https://eneqd3r9zrjok.x.pipedream.net/",
    "prefill": {
      //Here we are prefilling random contact
      "contact": "7769837705",
      //name and email id, so while checkout
      "name": "Anand B",
      "email": "anand.bidnur@viotalworks.com"
    },
    "notes": {
      "description": "TEST",
    },
    "theme": {
      "color": "#2300a3"
    }
  };
  payEvent() {
// console.log("In Pay")
    //this.walletTopUpModal.hide();
    this.closeWalletPopUp();

    this.showLoader = true;
    this.changePassMsg = "";
    this.confirmPassErrMsg = "";

    let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/createOrder";
    let body = {
      "amount": parseInt(this.amountToaddinwallet) * 100,
      "currency": "INR",
      "receipt": "order_rcptid_11",
      "notes": {}
    }
    this.amount = parseInt(this.amountToaddinwallet);
    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      // if (successResp['errorCode'] == "000000") {
      //console.log("Set Password .....", JSON.stringify(successResp));       
      this.razorOrderId = successResp["id"];
      //  this.options["order_id"] = this.razorOrderId;
      //  this.razorpayObject = new this.commonServices.nativeWindow.Razorpay(this.options);

      // this.razorpayObject.open();

      this.payWithRazor();

      //  }
      // else {
      //   this.confirmPassErrMsg = successResp["errorDescription"];
      // }
    })



  }

  public payWithRazor() {
  
    const options: any = {
      // const key_secret = "Ph7MgPiQKbCKjT0OCjb8n90k";//Live server
      key: razerpaykey_Id,
      //key: 'rzp_test_YJpYX80CozUKWx', //1234
      amount: this.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: '', // company name or product name
      description: '',  // product description
      image: './assets/logo.png', // company logo or product image
      order_id: this.razorOrderId, // order_id created by you in backend      
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },

      prefill: {
        name: 'razorpay',
        email: 'testing@razorpay.com',
        contact: '+918888888888',
        'card[number]': '4111111111111111',
        'card[expiry]': '1123',
        'card[cvv]': '123'
      },
      "notes": {
        "address": "Razorpay Corporate Office"
      },
      "theme": {
        "color": "#3399cc"
      }
    };
    let id = this.userID;
    let amt = this.amount;
    let url = this.configSetting.getBaseUrl();

    options.handler = ((response: any, error: any) => {
      //options.response = response;
      //console.log(response);
      if (response.razorpay_order_id != undefined || response.razorpay_payment_id != undefined || response.razorpay_signature) {
       
        let param = {
          "userid": this.userID,
          "razor_orderid": response.razorpay_order_id,
          "razor_paymentid": response.razorpay_payment_id,
          "amount": this.amount,
          "paymentstatus": "S"
        }
        let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/saveUserPaymentsDetails";
        this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
      // console.log(successResp);
          // console.log(this.walletTopUpModal.isShown)
          
          // this.closewalletTopUpModal();
          this.walletAmount = successResp["Data"]["walletbalance"];
          //this.dashboardComp.balance=this.walletAmount;
          //this.dashboardComp.balance=this.walletAmount;
          this.wallettext = "Amount Successfully Added in Wallet!!";
          //this.ispaymentSuccess=true;
      // console.log(this.walletAmount);
         
          setTimeout(() => {
            // this.walletTopUpAfterSuccessModal.show();
            this.openWalletPopUP();
            rzp.close();
          }, 800)

        })

      }
    });

    // const check = this.checkIfTheScriptFileIsAlreadyLoadedOrNot();

    // if (!check) {
    //   this.loadRazorPayScriptFileAsItIsNotLoadedAlready();
    // }

    const rzp = new this.commonServices.nativeWindow.Razorpay(options);
// console.log(rzp);
    rzp.open("_blank");
    
    //var rzp1 = new Razorpay(options);
// console.log(this.userID)

    rzp.on('payment.failed', (response: any) => {
  // console.log(response)
      
      /* alert(response.error.code);
       alert(response.error.description);
       alert(response.error.source);
       alert(response.error.step);
       alert(response.error.reason);
       alert(response.error.metadata.order_id);
       alert(response.error.metadata.payment_id);*/
      let param = {
        "userid": id,
        "razor_orderid": response.error.metadata.order_id,
        "razor_paymentid": "0",
        "amount": amt,
        "paymentstatus": "F"
      }
  // console.log("Sample Data", this.configSetting);
  console.log("From wallet service");
  
      let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/saveUserPaymentsDetails";
  // console.log(apiUrl)
        ; this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
      // console.log(successResp);
      // console.log(rzp);
          //alert("Payment Failed")  
          // this.closewalletTopUpModal();
          this.walletAmount = successResp["Data"]["walletbalance"];
          //this.dashboardComp.balance=this.walletAmount;
          // this.dashboardComp.balance=this.walletAmount;
          this.openWalletPopUP();
          this.wallettext = "Payment Fail Try Again";
          // this.walletTopUpModal.show();
        })
    });

    rzp.on('', function (response: any) {

    });

    //this.amount=0;
  }

  walletDisplay(page) {
this.page=page

    this.userID = this.dataManipSrvc.userId;
    let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/getWalletBalance";
    let param = { }
    this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.walletAmount = successResp['Data'][0]['walletbalance'];
        this.openWalletPopUP();

      }
    });
    //this.walletTopUpModal.show();
    //return this.walletAmount;


  }

  loadRazorPayScriptFileAsItIsNotLoadedAlready = () => {
    const node = document.createElement('script');
    node.src = 'https://checkout.razorpay.com/v1/checkout.js'
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  openWalletPopUP() {

     this.modalRef = this.NgbModal.open(WalletTopupComponent, { windowClass: "newlocation-modal" });
// console.log("InService OpenTopup")
    this.modalRef.componentInstance.wallettext = this.wallettext;
    this.modalRef.componentInstance.walletAmount = this.walletAmount;
// console.log(this.modalRef);

  }
  closeWalletPopUp() {
    //const modalRef = this.NgbModal.open(WalletTopupComponent, { windowClass: "newlocation-modal" });
// console.log("In Close Tp up")
    this.modalRef.dismiss();
    this.balanceupdate.updateBalance(this.page)
    //this.NgbModal;
  }
  dealytowalletPopup(){
    setTimeout(()=>{
      if(this.NgbModal.hasOpenModals()){
        this.closeWalletPopUp();
      }
      else{
        this.openWalletPopUP();
      }
    },1000)
  }
}
